export default __webpack_public_path__ + "static/Titan-9d74d24e9b6b2ff21f2772a80090657f.jpg";